import React, { useEffect, useRef, useState } from 'react';
import DownloadIcon from "../../assets/images/icon/download_icon.svg";

const familyLinks = [
  { label: '광고인사이드', href: 'https://adperson-inside.com/' },
  { label: '광고인커리어', href: 'https://adperson.career.greetinghr.com/ko/main' },
];

const downloadLinks = [
  {
    label: '지명원',
    href: 'https://adperson2.mycafe24.com/boonyang/pdf/namelist.pdf',
    filename: '지명원.pdf',
  },
  {
    label: '파트너 제안서',
    href: 'https://adperson2.mycafe24.com/boonyang/pdf/partnership.pdf',
    filename: '파트너제안서.pdf',
  },
];

const snsLinks = [
  {
    href: 'https://www.instagram.com/adperson_official/',
    label: '인스타그램',
    icon: 'https://adperson2.mycafe24.com/boonyang/main/icon_insta.png',
  },
  {
    href: 'https://www.youtube.com/@%EA%B4%91%EA%B3%A0%EC%9D%B8%EC%82%AC%EC%9D%B4%EB%93%9C_2025',
    label: '유튜브',
    icon: 'https://adperson2.mycafe24.com/boonyang/main/icon_youtube.png',
  },
];

const Footer: React.FC = () => {
  const [familyOpen, setFamilyOpen] = useState(false);
  const familyRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!familyRef.current?.contains(event.target as Node)) {
        setFamilyOpen(false);
      }
    };
    if (familyOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [familyOpen]);

  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setFamilyOpen(false);
      }
    };
    if (familyOpen) {
      document.addEventListener('keydown', handleEsc);
    }
    return () => document.removeEventListener('keydown', handleEsc);
  }, [familyOpen]);

  return (
    <footer className="bg-[#0d0d0d] py-16 text-white md:py-[70px]">
      <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-12 px-5 md:flex-row md:items-start md:justify-between md:px-6 lg:px-8">
        <div className="flex-1 space-y-6">
          <div className="flex flex-wrap items-center gap-6 md:gap-[20px]">
            {downloadLinks.map((item, idx) => (
              <React.Fragment key={item.label}>
                <a
                  href={item.href}
                  download={item.filename}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-2 text-lg font-semibold md:text-[20px]"
                >
                  <span>{item.label} 다운로드</span>
                  <img src={DownloadIcon} alt=""/>
                </a>
                {idx < downloadLinks.length - 1 ? (
                  <span className="hidden text-white/80 md:inline">|</span>
                ) : null}
              </React.Fragment>
            ))}
          </div>

          <div className="text-sm font-light leading-7 text-white/90 md:text-base md:leading-[30px]">
            <p>
              법인명 : (주)광고인 | 대표이사 : 문시욱
              <br className="md:hidden" /> 사업자등록번호 : 268-88-01715
            </p>
            <p>주소 : 광주광역시 북구 군왕로51번길 118(두암동)</p>
            <p>
              대표전화 : 1668-0002 | FAX : 0507-1799-4822
              <br className="md:hidden" /> 대표 이메일 : ad-person7@naver.com
            </p>
          </div>
        </div>

        <div className="flex w-full flex-col items-start gap-6 md:w-auto md:items-end">
          <div className="relative" ref={familyRef}>
            <button
              type="button"
              onClick={() => setFamilyOpen((prev) => !prev)}
              className="flex w-full items-center justify-between rounded bg-[#d9d9d9] px-4 py-3 text-left text-base font-semibold text-[#0d0d0d] transition md:w-[220px]"
            >
              패밀리 사이트
              <span
                className={`ml-3 text-xs transition-transform duration-300 ${
                  familyOpen ? 'rotate-180' : ''
                }`}
              >
                ▼
              </span>
            </button>
            <div
              className={`absolute left-0 top-full mt-2 flex w-full flex-col rounded border border-slate-200 bg-white text-sm text-[#0d0d0d] shadow-xl transition ${
                familyOpen ? 'visible opacity-100' : 'invisible opacity-0'
              }`}
            >
              {familyLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-2 px-4 py-3 hover:bg-slate-100"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div className="flex items-center gap-3">
            {snsLinks.map((sns) => (
              <a key={sns.href} href={sns.href} target="_blank" rel="noreferrer">
                <img
                  src={sns.icon}
                  alt={sns.label}
                  className="h-[30px] w-[30px] object-cover"
                />
              </a>
            ))}
          </div>

          <p className="text-sm font-light text-white/70">
            Copyright © {new Date().getFullYear()} (주)광고인
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
